import { Component,OnInit, ViewChild} from '@angular/core';
import { NavController,AlertController, Navbar,App } from 'ionic-angular';
import { StorageService } from '../../../providers/service/storageservice';
import { Utils } from '../../../providers/service/utils';
import { HttpService } from '../../../providers/service/httpservice';
import { LOGIN, CHECK_BIND_MAIL, SEND_EMAIL_CODE, SAVE_BIND_MAIL, CHECK_IS_WEAK_PWD } from '../../../providers/config/serviceurl';
import { AppState } from '../../../app/app.global';
import { SubmitPersonalInfoPage } from '../account/submitinfo/submitinfo';
import { RetrieveListPage } from '../password/items/list';
import { TabsPage } from '../../tabs/tabs/tabs';
import { BindEmailPage } from '../email/bind/bindEmail';
import { ModifyPasswordPage } from '../password/modify/modifyPwd';

@Component({
  selector: 'login-page',
  templateUrl: 'login.html'
})

export class LoginPage implements OnInit {

	currentUser:any;
	user={
		username:'',
		pwd:''
	}
	opid:any;
	@ViewChild(Navbar) navBar:Navbar;
	constructor (public navCtrl: NavController,public global: AppState
			,private httpService:HttpService,private alertCtrl: AlertController, private appCtrl:App) {
		StorageService.setObj("fromlogin",true);
		this.currentUser = StorageService.getObj("currentUser");
		this.opid = StorageService.getObj("opid");
		/* if(this.currentUser&&this.currentUser.userId!=''&&this.currentUser.userId!=null){
			this.appCtrl.getRootNav().setRoot(TabsPage);
		} */
	}

	ionViewDidLoad(){
		this.navBar.backButtonClick = this.backButtonClick;
	}
	//初始化
	ngOnInit(): void {}
	//登陆方法
	login(){
		if(this.user.username == ""){
			let alert = this.alertCtrl.create({
				subTitle: '用户名或工号不能为空',
				buttons: ['确定']
			});
			alert.present();
		}else if(this.user.pwd == ""){
			let alert = this.alertCtrl.create({
				subTitle: '密码不能为空',
				buttons: ['确定']
			});
			alert.present();
		}else{
			// let params1 = { accountKey: Utils.base64Encode(this.user.username), accountPwd: Utils.base64Encode(this.user.pwd) };
			// this.httpService.get2(CHECK_IS_WEAK_PWD, params1).then(data =>{
			// 	// 弱密码验证是否通过
			// 	if (data && data.ischeck === '1') {
			// 		let params2 = {'password':Utils.base64Encode(this.user.pwd),'username':Utils.base64Encode(this.user.username),'opid':this.opid};
			//         this.httpService.post2(LOGIN,params2).then(anyObj =>this.handleThings(anyObj));
			// 	} else {
			// 		StorageService.setObj("accountKey", this.user.username);
			// 		this.navCtrl.push(ModifyPasswordPage,{});
			// 	}
			// });
			let params2 = {'password':Utils.base64Encode(this.user.pwd),'username':Utils.base64Encode(this.user.username),'opid':this.opid};
			this.httpService.post2(LOGIN,params2).then(anyObj =>this.handleThings(anyObj));
		}
	}
	handleThings(obj :any){
		console.log('obj===' + JSON.stringify(obj));
		if(obj){
			// 判断用户是否锁定及其他情况
			if (obj.hasOwnProperty('error') && obj.error === 'error') {
                let alert = this.alertCtrl.create({
					subTitle:obj.message,
					buttons: ['确定']
				});    
				alert.present();
			} else {
				console.log('currentUser==' +obj.currentUser );
				console.log('resourceUrl==' +obj.resourceUrl );
				this.currentUser = obj.currentUser;
				
				this.clearPersonalizedSetting();
				StorageService.setObj("resourceUrl",obj.resourceUrl);
				StorageService.setObj("currentUser",this.currentUser);
				StorageService.setObj("oldUserId",this.currentUser.userId);//保存老用户的userId，在重新登录之后判断 是否需要删除个性化设置
				if(this.currentUser&&this.currentUser.userId!=null&&this.currentUser.userId!=''){
					 // this.navCtrl.push(TabsPage,{});
					 // this.navCtrl.popToRoot();
					let params1 = { accountKey: Utils.base64Encode(this.user.username), accountPwd: Utils.base64Encode(this.user.pwd) };
					this.httpService.get2(CHECK_IS_WEAK_PWD, params1).then(data =>{
						// 弱密码验证是否通过
						if (data && data.ischeck === '1') {
							//  账号是否已绑定邮箱
							let params = { accountKey: Utils.base64Encode(this.currentUser.username) };
							this.httpService.get2(CHECK_BIND_MAIL, params).then(data =>{
								if (data && data.data && data.data.bindMail === '1') {
									this.appCtrl.getRootNav().setRoot(TabsPage);
								} else {
									this.navCtrl.push(BindEmailPage,{});
								}
							});
						} else {
							StorageService.setObj("accountKey", this.user.username);
							this.navCtrl.push(ModifyPasswordPage,{});
						}
					});
					// this.appCtrl.getRootNav().setRoot(TabsPage);
					//  this.navCtrl.getActive().dismiss();
					 
				}
			}
			
		}
	}
	activeAccount() {
		this.navCtrl.push(SubmitPersonalInfoPage,{});
    }
	retrievePassword(){
		window.location.href = 'http://cas0.peizheng.edu.cn/uid/forget';
		// this.navCtrl.push(RetrieveListPage,{});
	}
	goback(){
		this.navCtrl.push(TabsPage,{});
	}

	backButtonClick = (e:UIEvent)=>{
		
		this.navCtrl.push(TabsPage,{});
	}

	/**如果现在登录的用户和之前不同，删除之前的用户个性化设置， */
	clearPersonalizedSetting(){
		let oldUserId = StorageService.getObj("oldUserId");
		if(oldUserId == null || oldUserId ==undefined || oldUserId == '' || this.currentUser.userId != oldUserId){
			//StorageService.localStorageClear();
			StorageService.localStorageClearExcludeApkVersion();
			this.resetColorTheme();
			
		}
	} 

	/**重置系统默认主题颜色 */
	resetColorTheme(){
		StorageService.setObj('colorTheme',"color40A0F6");
			this.global.setTheme("color40A0F6");
	}
}



// WEBPACK FOOTER //
// ./src/pages/login/login/login.ts